import React, { useState, useEffect, useRef } from "react";

import "./dishComponent.css";

import DishEditor from "../_dishEditor/DishEditor";

const DishComponent = ({
  dish,
  dishes,
  handleCopyDish,
  handleUpdateDish,
  handleDeleteDish
}) => {
  const [isEdited, setIsEdited] = useState(false);
  const [isDeleteDishBtnShown, setDeleteDishBtnShown] = useState(false);

  const [isDeleting, setIsDeleting] = useState(false);

  let timeoutRef = useRef(null);

  const deleteDish = () => {
    setIsDeleting(true);
  };

  useEffect(() => {
    if (isDeleting) {
      timeoutRef.current = setTimeout(() => handleDeleteDish(dish._id), 500);
    }
  }, [isDeleting]);

  /* unmount cleanup */
  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  return !isEdited ? (
    <div
      className={`dishComponent ${isDeleting ? `dishComponent--deleting` : ""}`}
    >
      <div className="dishComponent__controlsCopyDeleteDiv">
        <button
          className="controlsCopyDeleteDiv__copyBtn"
          onClick={() => handleCopyDish(dish)}
        >
          <svg
            className="controlsCopyDeleteDiv__copyBtn__svg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="var(--btn-border-color-green)"
            width="2em"
            height="2em"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
          </svg>
        </button>
        <button
          className="controlsCopyDeleteDiv__deleteBtn"
          onClick={() => setDeleteDishBtnShown(true)}
        >
          <svg
            className="controlsCopyDeleteDiv__deleteBtn__svg"
            width="1.8em"
            height="1.8em"
            viewBox="0 0 16 16"
            fill="var(--btn-border-color-red)"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353L11.46.146zm-6.106 4.5a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
            />
          </svg>
        </button>
      </div>
      <div className="dishComponent__dishBodyDiv">
        <div className="dishBodyDiv__nameDiv">
          <h4>name</h4>
          <div>{dish.name}</div>
        </div>
        <div className="dishBodyDiv__categoryDiv">
          <h4>category</h4>
          <div>{dish.category}</div>
        </div>
        <div className="dishBodyDiv__subcategoryDiv">
          <h4>subcategory</h4>
          <div>{dish.subcategory}</div>
        </div>
        <div className="dishBodyDiv__servingDiv">
          <h4>serving size</h4>
          <div>{dish.serving} g</div>
        </div>
        <div className="dishBodyDiv__macrosDiv">
          <h4>macros</h4>
          <div>{dish.macros ? dish.macros : "unset"}</div>
        </div>
        <div className="dishBodyDiv__expirationDiv">
          <h4>expiration time</h4>
          <div>{dish.expiration ? `${dish.expiration} h` : "unset"}</div>
        </div>
        <div className="dishBodyDiv__priceDiv">
          <h4>price</h4>
          <div>{dish.price} $</div>
        </div>
        <div className="dishBodyDiv__caloriesDiv">
          <h4>calories</h4>
          <div>{dish.calories ? `${dish.calories} ккл` : "unset"}</div>
        </div>
        <div className="dishBodyDiv__compositionDiv">
          <h4>composition</h4>
          <div>{dish.composition ? dish.composition : "unset"}</div>
        </div>
        <div className="dishBodyDiv__descriptionDiv">
          <h4>description</h4>
          <div>{dish.description ? dish.description : "unset"}</div>
        </div>
        <div className="dishBodyDiv__pictureDiv">
          {dish.pictureURL ? (
            <img src={dish.pictureURL} alt="" />
          ) : (
            <div>No picture uploaded</div>
          )}
        </div>
      </div>
      <div className="dishComponent__controlsDiv">
        <button
          className="controlsDiv__editDishBtn"
          onClick={() => setIsEdited(true)}
        >
          EDIT
        </button>
      </div>
      <div
        className={`dishComponent__confirmDeleteDishDiv
                            ${
                              isDeleteDishBtnShown
                                ? "dishComponent__confirmDeleteDishDiv--shown"
                                : ""
                            }
                        `}
      >
        <div>Do you want to delete item from the database?</div>
        <button
          className="confirmDeleteDishDiv__cancelBtn"
          onClick={() => setDeleteDishBtnShown(false)}
        >
          Cancel
        </button>
        <button
          className="confirmDeleteDishDiv__deleteBtn"
          onClick={deleteDish}
        >
          Confirm
        </button>
      </div>
    </div>
  ) : (
    <DishEditor
      dish={dish}
      dishes={dishes}
      isFromUpdate={true}
      handleUpdateDish={handleUpdateDish}
      closeEditorFormCallBack={() => setIsEdited(false)}
    />
  );
};

export default DishComponent;
